"use client";

import { Suspense, useEffect, type ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SnackbarProvider } from "notistack";

import { theme } from "@/theme";
import AppProviders from "@/context/AppProvidesrs";
import { UserProvider } from "@/context/userContext";
import { LoaderProvider } from "@/context/loaderContext";
import { ConversationalProvider } from "@/context/ConversationalContext";
import { initializeGA4 } from "@/api/services/ga.service";
import TrailingSlashFix from "@/components/TrailingSlashFix";
import FormbricksProvider from "@/context/formBricksProvider";

export default function ClientProviders({
  children,
}: {
  children: ReactNode;
}) {
  useEffect(() => initializeGA4(), []);

  return (
    <GoogleOAuthProvider
      clientId={
        process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID! ||
        "280064138488-md6sf7de7f32da5stadmf6ciegchc7nt.apps.googleusercontent.com"
      }
    >
      <TrailingSlashFix />
      <AppProviders>
        <SnackbarProvider>
          <LoaderProvider>
            <UserProvider>
              <Suspense fallback={null}>
                <FormbricksProvider />
                <ConversationalProvider>
                  <InitColorSchemeScript attribute="class" />
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    {children}
                  </ThemeProvider>
                </ConversationalProvider>
              </Suspense>
            </UserProvider>
          </LoaderProvider>
        </SnackbarProvider>
      </AppProviders>
    </GoogleOAuthProvider>
  );
}
